import axios from "axios";
import { useState, useEffect } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import "../../assets/css/Loader.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function Customer() {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [responseData, setResponseData] = useState([]);
  const [generateNumber, setGenerateNumber] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");
  const [isTranslating, setIsTranslating] = useState(false);
  
  const [addData, setAddData] = useState({
    customer_type: "",
    customer_id: "",
    name: "",
    name_tamil: "",
    mobile: "",
    aadhar_number: "",
    address: "",
    status: "",
    created_by: "system",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateData, setUpdateData] = useState({
    id: "",
    customer_type: "",
    customer_id: "",
    name: "",
    name_tamil: "",
    mobile: "",
    aadhar_number: "",
    address: "",
    status: "",
    created_by: "",
    created_date: "",
    updated_by: "system",
    updated_date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  // ─── Tamil Translation ───────────────────────────────────────────────────────
  const translateToTamil = async (englishText) => {
    if (!englishText || englishText.trim().length < 2) return "";
    setIsTranslating(true);

    try {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(
        `https://inputtools.google.com/request?text=${encoded}&itc=ta-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8`
      );
      const data = await res.json();

      if (data && data[0] === "SUCCESS") {
        const result = data[1]?.[0]?.[1]?.[0];
        if (result) {
          setIsTranslating(false);
          return result;
        }
      }
    } catch (error) {
      console.warn("Transliteration failed:", error);
    }

    setIsTranslating(false);
    return "";
  };

  // ─── Modal Handlers ──────────────────────────────────────────────────────────
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setAddData({
      customer_type: "",
      customer_id: "",
      name: "",
      name_tamil: "",
      mobile: "",
      aadhar_number: "",
      address: "",
      status: "",
      created_by: "system",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setGenerateNumber("");
    setValidationErrors({});
    setActionType("");
  };

  const closeUpdateModal = () => {
    setUpdateModal(false);
    setUpdateData({
      id: "",
      customer_type: "",
      customer_id: "",
      name: "",
      name_tamil: "",
      mobile: "",
      aadhar_number: "",
      address: "",
      status: "",
      created_by: "",
      created_date: "",
      updated_by: "system",
      updated_date: "",
    });
    setGenerateNumber("");
    setValidationErrors({});
  };

  const openNotificationModal = (id, action) => {
    setSelectedCustomerId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedCustomerId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  // ─── Notifications ───────────────────────────────────────────────────────────
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error("Failed to fetch notifications", 3000, "topRight");
    }
  };

  const checkNotificationStatus = (customerId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === customerId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const hasPendingNotification = (customerId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === customerId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedCustomerId, actionType)) {
      toast.warning("A pending request for this action already exists!");
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "customer",
        table_id: selectedCustomerId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        "Error submitting notification. Please try again.",
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // ─── Data Fetching ───────────────────────────────────────────────────────────
  const fetchData = async () => {
    const localRole = localStorage.getItem("role");
    const localUsername = localStorage.getItem("username");

    const isEmployee = localRole === "Employee";
    const url = isEmployee
      ? `${ApiUrl}/Api/customer.php?employee_id=${localUsername}`
      : `${ApiUrl}/Api/customer.php`;

    try {
      const response = await axios.get(url);
      const data = response.data?.data || [];
      console.log("Response from server:", response.data);
      setResponseData(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
    }
  };

  // ─── Generate IDs ────────────────────────────────────────────────────────────
  const generateCustomerId = async (customerType) => {
    if (customerType === "Walk-In") {
      try {
        const response = await axios.get(
          `${ApiUrl}/Api/customer.php/generate-walkin-code`
        );
        const data = response.data?.customer_id || "";
        setGenerateNumber(data);
      } catch (error) {
        console.error("Error fetching generated ID:", error.message);
        setGenerateNumber("");
      }
    } else {
      try {
        const response = await axios.get(
          `${ApiUrl}/Api/customer.php/generate-customer-code`
        );
        const data = response.data?.customer_id || "";
        setGenerateNumber(data);
      } catch (error) {
        console.error("Error fetching generated ID:", error.message);
        setGenerateNumber("");
      }
    }
  };

  const handleAddButtonClick = () => {
    setAddData({
      customer_type: "",
      customer_id: "",
      name: "",
      name_tamil: "",
      mobile: "",
      aadhar_number: "",
      address: "",
      status: "",
      created_by: "system",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setGenerateNumber("");
    setValidationErrors({});
    openModal();
  };

  const handleCustomerTypeChange = (e) => {
    const customerType = e.target.value;
    setAddData({ ...addData, customer_type: customerType });
    generateCustomerId(customerType);
  };

  // ─── Validation ──────────────────────────────────────────────────────────────
  const validateForm = (data) => {
    const errors = {};
    if (!data.customer_type) errors.customer_type = "Customer type is required";
    if (!data.name) errors.name = "Name is required";
    if (!data.mobile) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(data.mobile)) {
      errors.mobile = "Mobile number must be 10 digits";
    }
    if (!data.aadhar_number) {
      errors.aadhar_number = "Aadhar number is required";
    } else if (!/^\d{12}$/.test(data.aadhar_number)) {
      errors.aadhar_number = "Aadhar number must be 12 digits";
    }
    if (!data.status || data.status === "Select Status") {
      errors.status = "Status is required";
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ─── CRUD ────────────────────────────────────────────────────────────────────
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(addData)) return;

    try {
      setLoading(true);
      
      // Auto-translate if Tamil name is empty
      let finalTamilName = addData.name_tamil;
      if (!finalTamilName && addData.name) {
        finalTamilName = await translateToTamil(addData.name);
      }

      const formData = {
        ...addData,
        name_tamil: finalTamilName || "",
        customer_id: generateNumber,
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      const response = await axios.post(`${ApiUrl}/Api/customer.php`, formData);
      toast.success("Added successfully!", 3000, "topRight");
      closeModal();
      fetchData();
    } catch (error) {
      console.error("Error adding data:", error.message);
      toast.error("Failed to add data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleUpdate = (id, data) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Edit")) {
        setUpdateId(id);
        setUpdateData({
          id,
          customer_type: data.customer_type || "",
          customer_id: data.customer_id || "",
          name: data.name || "",
          name_tamil: data.name_tamil || "",
          mobile: data.mobile || "",
          aadhar_number: data.aadhar_number || "",
          address: data.address || "",
          status: data.status || "",
          created_by: data.created_by || "",
          created_date: data.created_date || "",
          updated_by: "system",
          updated_date: "",
        });
        setGenerateNumber(data.customer_id);
        setUpdateModal(true);
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      setUpdateId(id);
      setUpdateData({
        id,
        customer_type: data.customer_type || "",
        customer_id: data.customer_id || "",
        name: data.name || "",
        name_tamil: data.name_tamil || "",
        mobile: data.mobile || "",
        aadhar_number: data.aadhar_number || "",
        address: data.address || "",
        status: data.status || "",
        created_by: data.created_by || "",
        created_date: data.created_date || "",
        updated_by: "system",
        updated_date: "",
      });
      setGenerateNumber(data.customer_id);
      setUpdateModal(true);
    }
  };

  const handleUpdateCustomerTypeChange = (e) => {
    const customerType = e.target.value;
    setUpdateData({ ...updateData, customer_type: customerType });
    if (updateData.customer_type !== customerType) {
      generateCustomerId(customerType);
    }
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(updateData)) return;

    try {
      setLoading(true);
      
      // Auto-translate if Tamil name is empty
      let finalTamilName = updateData.name_tamil;
      if (!finalTamilName && updateData.name) {
        finalTamilName = await translateToTamil(updateData.name);
      }

      const formData = {
        ...updateData,
        name_tamil: finalTamilName || "",
        customer_id: generateNumber,
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      const response = await axios.put(
        `${ApiUrl}/Api/customer.php/${updateId}`,
        formData
      );

      const notification = notifications.find(
        (notif) =>
          notif.table_id === updateId.toString() &&
          notif.button_value === "Edit" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Updated successfully!", 3000, "topRight");
      closeUpdateModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to update data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleOpenModal = (id, customer_id) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Delete")) {
        setDeleteId(id);
        setDeleteName(customer_id);
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setDeleteId(id);
      setDeleteName(customer_id);
      setDeleteShowModals(true);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setDeleteId("");
    setDeleteName("");
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${ApiUrl}/Api/customer.php/${deleteId}`
      );

      const notification = notifications.find(
        (notif) =>
          notif.table_id === deleteId.toString() &&
          notif.button_value === "Delete" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Deleted successfully!", 3000, "topRight");
      handleCloseModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // ─── Filtering & Pagination ──────────────────────────────────────────────────
  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.customer_id &&
        item.customer_id.toLowerCase().includes(searchLower)) ||
      (item.customer_type &&
        item.customer_type.toLowerCase().includes(searchLower)) ||
      (item.name && item.name.toLowerCase().includes(searchLower)) ||
      (item.name_tamil && item.name_tamil.toLowerCase().includes(searchLower)) ||
      (item.mobile && item.mobile.toLowerCase().includes(searchLower)) ||
      (item.aadhar_number &&
        item.aadhar_number.toLowerCase().includes(searchLower)) ||
      (item.address && item.address.toLowerCase().includes(searchLower)) ||
      (item.status && item.status.toLowerCase().includes(searchLower))
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // ─── Export Helpers ──────────────────────────────────────────────────────────
  const getDisplayName = (item) =>
    item.name_tamil ? `${item.name} / ${item.name_tamil}` : item.name || "";

  // ─── Exports ─────────────────────────────────────────────────────────────────
  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
        <head>
          <title>Customer List</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .badge { padding: 2px 6px; border-radius: 3px; font-size: 12px; }
            .badge.active { background-color: #28a745; color: white; }
            .badge.inactive { background-color: #dc3545; color: white; }
            .badge.default { background-color: #6c757d; color: white; }
            .table-secondary { background-color: #e2e3e5; }
            .table-danger { background-color: #f8d7da; }
            .table-info { background-color: #cff4fc; }
          </style>
        </head>
        <body>
          <div class="header"><h2>Customer List</h2></div>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Customer Type</th>
                <th>Customer ID</th>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Aadhar Number</th>
                <th>Address</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((item, index) => {
                  const userId = localStorage.getItem("username");
                  const notification = notifications.find(
                    (notif) =>
                      notif.table_id === item.id.toString() &&
                      notif.employe_id === userId &&
                      notif.viewed === "false"
                  );
                  let rowClass = "";
                  if (notification) {
                    switch (notification.status) {
                      case "accepted":
                        rowClass = "table-secondary";
                        break;
                      case "rejected":
                        rowClass = "table-danger";
                        break;
                      case "requested":
                        rowClass = "table-info";
                        break;
                    }
                  }
                  const statusClass =
                    item.status === "Active"
                      ? "active"
                      : item.status === "Inactive"
                      ? "inactive"
                      : "default";
                  return `
                    <tr class="${rowClass}">
                      <td>${index + 1}</td>
                      <td>${item.customer_type || ""}</td>
                      <td>${item.customer_id || ""}</td>
                      <td>${getDisplayName(item)}</td>
                      <td>${item.mobile || ""}</td>
                      <td>${item.aadhar_number || ""}</td>
                      <td>${item.address || ""}</td>
                      <td><span class="badge ${statusClass}">${
                    item.status || ""
                  }</span></td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(20);
      doc.text("Customer List", 14, 22);
      doc.setFontSize(12);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

      const tableColumn = [
        "S.No",
        "Customer Type",
        "Customer ID",
        "Name",
        "Mobile Number",
        "Aadhar Number",
        "Address",
        "Status",
      ];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false"
        );
        let rowStyle = "";
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        return [
          index + 1,
          item.customer_type || "",
          item.customer_id || "",
          getDisplayName(item),
          item.mobile || "",
          item.aadhar_number || "",
          item.address || "",
          item.status || "",
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 45,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 25 },
          2: { cellWidth: 25 },
          3: { cellWidth: 35 },
          4: { cellWidth: 25 },
          5: { cellWidth: 25 },
          6: { cellWidth: 40 },
          7: { cellWidth: 20 },
        },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      doc.save("customer-list.pdf");
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = [
        "S.No",
        "Customer Type",
        "Customer ID",
        "Name",
        "Mobile Number",
        "Aadhar Number",
        "Address",
        "Status",
      ];
      const rows = filteredData.map((item, index) => [
        index + 1,
        item.customer_type || "",
        item.customer_id || "",
        getDisplayName(item),
        item.mobile || "",
        item.aadhar_number || "",
        item.address || "",
        item.status || "",
      ]);

      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(formattedText)
          .then(() => {
            toast.success(
              "Data copied to clipboard successfully!",
              3000,
              "topRight"
            );
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(formattedText);
          });
      } else {
        fallbackCopy(formattedText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Error copying data. Please try again.", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvData = [
        [
          "S.No",
          "Customer Type",
          "Customer ID",
          "Name",
          "Mobile Number",
          "Aadhar Number",
          "Address",
          "Status",
        ],
        ...filteredData.map((item, index) => [
          index + 1,
          item.customer_type || "",
          item.customer_id || "",
          getDisplayName(item),
          item.mobile || "",
          item.aadhar_number || "",
          item.address || "",
          item.status || "",
        ]),
      ];

      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "customer-list.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        "Customer Type": item.customer_type || "",
        "Customer ID": item.customer_id || "",
        Name: getDisplayName(item),
        "Mobile Number": item.mobile || "",
        "Aadhar Number": item.aadhar_number || "",
        Address: item.address || "",
        Status: item.status || "",
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      const colWidths = [
        { wch: 8 },
        { wch: 15 },
        { wch: 15 },
        { wch: 35 },
        { wch: 15 },
        { wch: 15 },
        { wch: 40 },
        { wch: 12 },
      ];
      ws["!cols"] = colWidths;
      XLSX.utils.book_append_sheet(wb, ws, "Customers");
      XLSX.writeFile(wb, "customer-list.xlsx");
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
    }
  };

  // ─── Effects ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid py-3">
        <div className="d-flex mb-4">
          <h6 className="card-title m-2">Customers</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={handleAddButtonClick}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>
              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: "50px" }}>S.No</th>
                      <th style={{ width: "150px" }}>Customer Type</th>
                      <th>Customer ID</th>
                      <th style={{ width: "300px" }}>Name</th>
                      <th>Mobile Number</th>
                      <th>Address</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => {
                        const userId = localStorage.getItem("username");
                        const notification = notifications.find(
                          (notif) =>
                            notif.table_id === item.id.toString() &&
                            notif.viewed === "false"
                        );
                        let rowClass = "";
                        if (notification) {
                          switch (notification.status) {
                            case "accepted":
                              rowClass = "table-secondary";
                              break;
                            case "rejected":
                              rowClass = "table-danger";
                              break;
                            case "requested":
                              rowClass = "table-info";
                              break;
                          }
                        }
                        return (
                          <tr key={item.id} className={rowClass}>
                            <td>{index + 1}</td>
                            <td>{item.customer_type}</td>
                            <td>{item.customer_id}</td>
                            <td>
                              {item.name}
                              {item.name_tamil && (
                                <span className="text-muted"> / {item.name_tamil}</span>
                              )}
                            </td>
                            <td>{item.mobile}</td>
                            <td>{item.address}</td>
                            <td>
                              {item.status === "Active" ? (
                                <span className="badge bg-success text-white">
                                  Active
                                </span>
                              ) : item.status === "Inactive" ? (
                                <span className="badge bg-danger text-white">
                                  Inactive
                                </span>
                              ) : (
                                <span className="badge bg-secondary text-white">
                                  {item.status}
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-light btn-sm mx-1"
                                onClick={() => handleUpdate(item.id, item)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-light btn-sm"
                                onClick={() =>
                                  handleOpenModal(item.id, item.customer_id)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No customers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add / Notification Modal ─────────────────────────────────────────── */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="addCustomerModalLabel"
              >
                {actionType
                  ? `Send ${actionType} Request to Admin`
                  : "Add Customer"}
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={actionType ? closeNotificationModal : closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {actionType ? (
                <form onSubmit={handleNotificationSubmit}>
                  <p className="text-center">
                    Do you want to request to {actionType.toLowerCase()} this
                    customer?
                  </p>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm px-4 me-2"
                      onClick={closeNotificationModal}
                    >
                      No
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                      disabled={isSubmitting}
                    >
                      Yes
                    </button>
                  </div>
                </form>
              ) : (
                <form onSubmit={handlesubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="customerType" className="form-label">
                          Customer Type <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-control ${
                            validationErrors.customer_type ? "is-invalid" : ""
                          }`}
                          id="customerType"
                          value={addData.customer_type}
                          onChange={handleCustomerTypeChange}
                          required
                        >
                          <option value="" disabled>
                            Select Customer Type
                          </option>
                          <option value="Walk-In">Walk-In</option>
                          <option value="Regular">Regular</option>
                          <option value="Retailer">Retailer</option>
                        </select>
                        {validationErrors.customer_type && (
                          <div className="invalid-feedback">
                            {validationErrors.customer_type}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="customerId" className="form-label">
                          Customer ID
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="customerId"
                          placeholder="Customer ID will be generated"
                          value={generateNumber}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Name <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className={`form-control ${validationErrors.name ? "is-invalid" : ""}`}
                            id="name"
                            placeholder="Enter Name"
                            value={addData.name}
                            onChange={(e) =>
                              setAddData({ ...addData, name: e.target.value, name_tamil: "" })
                            }
                            onBlur={async (e) => {
                              const val = e.target.value.trim();
                              if (val && !addData.name_tamil) {
                                const tamil = await translateToTamil(val);
                                if (tamil) setAddData((prev) => ({ ...prev, name_tamil: tamil }));
                              }
                            }}
                            required
                          />
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            style={{ height: "38px" }}
                            disabled={isTranslating || !addData.name}
                            onClick={async () => {
                              const tamil = await translateToTamil(addData.name);
                              if (tamil) setAddData((prev) => ({ ...prev, name_tamil: tamil }));
                            }}
                          >
                            {isTranslating ? (
                              <span className="spinner-border spinner-border-sm" />
                            ) : "🌐 தமிழ்"}
                          </button>
                        </div>
                        {addData.name_tamil && (
                          <small className="text-muted mt-1 d-block">
                            <strong>Tamil:</strong> {addData.name_tamil}
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0 ms-2 text-muted"
                              onClick={() => setAddData((prev) => ({ ...prev, name_tamil: "" }))}
                            >
                              ✕ clear
                            </button>
                          </small>
                        )}
                        {validationErrors.name && (
                          <div className="invalid-feedback d-block">{validationErrors.name}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="mobile" className="form-label">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength="10"
                          className={`form-control ${
                            validationErrors.mobile ? "is-invalid" : ""
                          }`}
                          id="mobile"
                          placeholder="Enter Mobile"
                          value={addData.mobile}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              setAddData({ ...addData, mobile: value });
                            }
                          }}
                          required
                        />
                        {validationErrors.mobile && (
                          <div className="invalid-feedback">
                            {validationErrors.mobile}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label htmlFor="aadharNumber" className="form-label">
                          Aadhar Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength="12"
                          className={`form-control ${
                            validationErrors.aadhar_number ? "is-invalid" : ""
                          }`}
                          id="aadharNumber"
                          placeholder="Enter Aadhar Number"
                          value={addData.aadhar_number}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,12}$/.test(value)) {
                              setAddData({ ...addData, aadhar_number: value });
                            }
                          }}
                          required
                        />
                        {validationErrors.aadhar_number && (
                          <div className="invalid-feedback">
                            {validationErrors.aadhar_number}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      placeholder="Enter Address"
                      value={addData.address}
                      onChange={(e) =>
                        setAddData({ ...addData, address: e.target.value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="customerStatus" className="form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select ${
                        validationErrors.status ? "is-invalid" : ""
                      }`}
                      id="status"
                      value={addData.status}
                      onChange={(e) =>
                        setAddData({ ...addData, status: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Status
                      </option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    {validationErrors.status && (
                      <div className="invalid-feedback">
                        {validationErrors.status}
                      </div>
                    )}
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ── Update Modal ─────────────────────────────────────────────────────── */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{
          display: updateModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="updateCustomerModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="updateCustomerModalLabel"
              >
                Update Customer
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleupdatesubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label
                        htmlFor="updateCustomerType"
                        className="form-label"
                      >
                        Customer Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control ${
                          validationErrors.customer_type ? "is-invalid" : ""
                        }`}
                        id="updateCustomerType"
                        value={updateData.customer_type}
                        onChange={handleUpdateCustomerTypeChange}
                        required
                      >
                        <option value="" disabled>
                          Select Customer Type
                        </option>
                        <option value="Walk-In">Walk-In</option>
                        <option value="Regular">Regular</option>
                        <option value="Retailer">Retailer</option>
                      </select>
                      {validationErrors.customer_type && (
                        <div className="invalid-feedback">
                          {validationErrors.customer_type}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateCustomerId" className="form-label">
                        Customer ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="updateCustomerId"
                        value={generateNumber}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateName" className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          className={`form-control ${validationErrors.name ? "is-invalid" : ""}`}
                          id="updateName"
                          placeholder="Enter Name"
                          value={updateData.name}
                          onChange={(e) =>
                            setUpdateData({ ...updateData, name: e.target.value, name_tamil: "" })
                          }
                          onBlur={async (e) => {
                            const val = e.target.value.trim();
                            if (val && !updateData.name_tamil) {
                              const tamil = await translateToTamil(val);
                              if (tamil) setUpdateData((prev) => ({ ...prev, name_tamil: tamil }));
                            }
                          }}
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          style={{ height: "38px" }}
                          disabled={isTranslating || !updateData.name}
                          onClick={async () => {
                            const tamil = await translateToTamil(updateData.name);
                            if (tamil) setUpdateData((prev) => ({ ...prev, name_tamil: tamil }));
                          }}
                        >
                          {isTranslating ? (
                            <span className="spinner-border spinner-border-sm" />
                          ) : "🌐 தமிழ்"}
                        </button>
                      </div>
                      {updateData.name_tamil && (
                        <small className="text-muted mt-1 d-block">
                          <strong>Tamil:</strong> {updateData.name_tamil}
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0 ms-2 text-muted"
                            onClick={() => setUpdateData((prev) => ({ ...prev, name_tamil: "" }))}
                          >
                            ✕ clear
                          </button>
                        </small>
                      )}
                      {validationErrors.name && (
                        <div className="invalid-feedback d-block">{validationErrors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateMobile" className="form-label">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        className={`form-control ${
                          validationErrors.mobile ? "is-invalid" : ""
                        }`}
                        id="updateMobile"
                        placeholder="Enter Mobile"
                        value={updateData.mobile}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setUpdateData({ ...updateData, mobile: value });
                          }
                        }}
                        required
                      />
                      {validationErrors.mobile && (
                        <div className="invalid-feedback">
                          {validationErrors.mobile}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label htmlFor="updateAadharNumber" className="form-label">
                        Aadhar Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="12"
                        className={`form-control ${
                          validationErrors.aadhar_number ? "is-invalid" : ""
                        }`}
                        id="updateAadharNumber"
                        placeholder="Enter Aadhar Number"
                        value={updateData.aadhar_number}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,12}$/.test(value)) {
                            setUpdateData({ ...updateData, aadhar_number: value });
                          }
                        }}
                        required
                      />
                      {validationErrors.aadhar_number && (
                        <div className="invalid-feedback">
                          {validationErrors.aadhar_number}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="updateAddress" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="updateAddress"
                    placeholder="Enter Address"
                    value={updateData.address}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, address: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="updateStatus" className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      validationErrors.status ? "is-invalid" : ""
                    }`}
                    id="updateStatus"
                    value={updateData.status}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, status: e.target.value })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {validationErrors.status && (
                    <div className="invalid-feedback">
                      {validationErrors.status}
                    </div>
                  )}
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary btn-sm px-4">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ── Delete Modal ─────────────────────────────────────────────────────── */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete this
                <span className="text-primary">({deleteName})</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default Customer;